import { createStore } from 'zustand/vanilla';
import { loadRuntimeConfig } from '../../api/config';

export type AiImportView =
  { kind: 'wizard'; sessionId: string | null } | { kind: 'history' } | null;

/** Which AI import dialog is open (wizard for a new / stored session, or the history list). */
export const aiImportStore = createStore<{
  view: AiImportView;
  openNew(): void;
  openSession(sessionId: string): void;
  openHistory(): void;
  close(): void;
}>()((set) => ({
  view: null,
  openNew: () => set({ view: { kind: 'wizard', sessionId: null } }),
  openSession: (sessionId) => set({ view: { kind: 'wizard', sessionId } }),
  openHistory: () => set({ view: { kind: 'history' } }),
  close: () => set({ view: null }),
}));

export interface AiConfig {
  enabled: boolean;
  model: string | null;
  maxPages: number;
}

export const DISABLED: AiConfig = { enabled: false, model: null, maxPages: 10 };

/** `aiImport` of the runtime config (absent on older servers = disabled). */
export const aiConfigStore = createStore<AiConfig & { loaded: boolean }>()(() => ({
  ...DISABLED,
  loaded: false,
}));

let loading: Promise<AiConfig> | null = null;

export function loadAiConfig(): Promise<AiConfig> {
  loading ??= Promise.resolve()
    .then(() => loadRuntimeConfig())
    .then((c) => c.aiImport ?? DISABLED)
    .catch(() => DISABLED)
    .then((cfg) => {
      const next = { enabled: cfg.enabled, model: cfg.model, maxPages: cfg.maxPages };
      aiConfigStore.setState({ ...next, loaded: true });
      return next;
    });
  return loading;
}

export function resetAiConfig(): void {
  loading = null;
  aiConfigStore.setState({ ...DISABLED, loaded: false });
}
